import ColorStyles from '@Resources/styles/colors.scss';
import Flex from '@Resources/styles/flex.scss';
import cx from 'classnames';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { WorkbenchType } from '@Data/workbenches/Interfaces';
import { selectedWorkbenchState } from '@Data/workbenches/Reducer';
import Styles from './EntityDrawer.scss';
import { isFalsy } from './EntityDrawerUtils';

export const enum NestLevel {
    BASE,
    NEST1,
    NEST2,
    VALUE,
    IMAGE,
}

export const enum ColumnWidth {
    SMALL,
    MEDIUM,
    LARGE,
}

export interface IEntityDrawerAttributeRowProps {
    keyName?: string;
    value: any;
    nestLevel?: NestLevel;
    columnWidth?: ColumnWidth;
    subElement?: JSX.Element;
    valueStyles?: React.CSSProperties;
}

const getTruncatedString = (val: any, maxLength: number): string => {
    if (isFalsy(val)) {
        return '-';
    } else if (typeof val !== 'string') {
        return val;
    } else if (val.length <= maxLength) {
        return val !== '' ? val : '-';
    } else {
        let newStr = val.substring(0, maxLength - 2);
        newStr += '...';
        return newStr;
    }
};

const EntityDrawerAttributeRow = (props: IEntityDrawerAttributeRowProps) => {
    const {
        keyName,
        value,
        nestLevel = NestLevel.BASE,
        subElement,
        columnWidth,
    } = props;

    const selectedWorkbench = useSelector(selectedWorkbenchState);

    return (
        <div
            className={cx(Styles.baseAttributeRow, Styles.attributeRowGeneric, {
                [Styles.attributeRowNestedBackground]:
                    nestLevel === NestLevel.VALUE,
                [Styles.attributeRowQc]: selectedWorkbench === WorkbenchType.QC,
            })}
        >
            {selectedWorkbench !== WorkbenchType.QC && keyName && (
                <div
                    className={
                        nestLevel === NestLevel.VALUE
                            ? Styles.attributeRowDashValue
                            : Styles.attributeRowDash
                    }
                />
            )}
            {keyName && (
                <div className={Styles.attributeRowKey}>
                    <span
                        className={cx({
                            [Styles.attributeRowEmptyValue]: isFalsy(value),
                        })}
                    >
                        {getTruncatedString(keyName, 60)}
                    </span>
                </div>
            )}
            <div
                className={
                    columnWidth === ColumnWidth.SMALL
                        ? Styles.attributeRowValueSm
                        : Styles.attributeRowValueMd
                }
            >
                <span
                    className={cx(
                        {
                            [Styles.attributeRowImageContainer]:
                                nestLevel === NestLevel.IMAGE,
                        },
                        { [Styles.attributeRowEmptyValue]: isFalsy(value) }
                    )}
                    style={props.valueStyles}
                >
                    {value}
                </span>
            </div>
            {subElement && (
                <div className={Styles.attributeRowSubelement}>
                    {subElement}
                </div>
            )}
        </div>
    );
};

export default EntityDrawerAttributeRow;
